(function () {
  // ---- Config (pulled from Theme Customizer via main-cart.liquid) ----
  var configEl = document.getElementById("product-ack-config");
  var TITLE = (configEl && configEl.dataset.title) || "Product Acknowledgement";
  var DESCRIPTION = (configEl && configEl.dataset.description) || "";

  if (!DESCRIPTION) return; // don't show an empty popup if misconfigured

  // ---- Overlay ----
  var overlay = document.createElement("div");
  overlay.setAttribute("id", "product-ack-overlay");
  overlay.style.cssText = [
    "position:fixed",
    "top:0",
    "left:0",
    "width:100%",
    "height:100%",
    "background:rgba(0,0,0,0.55)",
    "z-index:999999",
    "display:flex",
    "align-items:center",
    "justify-content:center",
    "font-family:Arial, Helvetica, sans-serif"
  ].join(";");

  // ---- Modal ----
  var modal = document.createElement("div");
  modal.style.cssText = [
    "background:#ffffff",
    "max-width:480px",
    "width:90%",
    "padding:24px",
    "border-radius:8px",
    "box-shadow:0 10px 30px rgba(0,0,0,0.3)",
    "box-sizing:border-box"
  ].join(";");

  var title = document.createElement("h2");
  title.textContent = TITLE;
  title.style.cssText = "margin:0 0 12px 0;font-size:20px;color:#1a1a1a;";

  var desc = document.createElement("p");
  desc.textContent = DESCRIPTION;
  desc.style.cssText = "margin:0 0 20px 0;font-size:14px;line-height:1.5;color:#333333;white-space:pre-line;";

  var buttonRow = document.createElement("div");
  buttonRow.style.cssText = "display:flex;justify-content:flex-start;";

  var confirmBtn = document.createElement("button");
  confirmBtn.textContent = "I confirm";
  confirmBtn.style.cssText = [
    "background:#1a1a1a",
    "color:#ffffff",
    "border:none",
    "padding:10px 20px",
    "font-size:14px",
    "border-radius:4px",
    "cursor:pointer"
  ].join(";");
  confirmBtn.onmouseover = function () { confirmBtn.style.opacity = "0.85"; };
  confirmBtn.onmouseout = function () { confirmBtn.style.opacity = "1"; };

  confirmBtn.addEventListener("click", function () {
    document.body.removeChild(overlay);
    document.body.style.overflow = ""; // restore scroll
  });

  buttonRow.appendChild(confirmBtn);
  modal.appendChild(title);
  modal.appendChild(desc);
  modal.appendChild(buttonRow);
  overlay.appendChild(modal);

  // ---- Show on every page load ----
  document.addEventListener("DOMContentLoaded", function () {
    document.body.appendChild(overlay);
    document.body.style.overflow = "hidden"; // prevent background scroll while open
  });
})();

// (function () {
//   // ---- Config ----
//   var TITLE = "Product + Delivery Acknowledgements";
//   var DESCRIPTION = "Aggregates, decorative rock, and other natural stone products are naturally sourced and may vary in colour, size, texture, shape, and appearance. Products may differ from previous purchases, website photos, or samples.\n\nProduct delivered on pallets, bagged or bulk orders exceeding six cubic yards may be subject to an additional delivery fee based on the truck required.\n\nBy continuing to checkout, you acknowledge and accept these natural variations and any applicable delivery fees.";

//   // ---- Overlay ----
//   var overlay = document.createElement("div");
//   overlay.setAttribute("id", "product-ack-overlay");
//   overlay.style.cssText = [
//     "position:fixed",
//     "top:0",
//     "left:0",
//     "width:100%",
//     "height:100%",
//     "background:rgba(0,0,0,0.55)",
//     "z-index:999999",
//     "display:flex",
//     "align-items:center",
//     "justify-content:center",
//     "font-family:Arial, Helvetica, sans-serif"
//   ].join(";");

//   // ---- Modal ----
//   var modal = document.createElement("div");
//   modal.style.cssText = [
//     "background:#ffffff",
//     "max-width:480px",
//     "width:90%",
//     "padding:24px",
//     "border-radius:8px",
//     "box-shadow:0 10px 30px rgba(0,0,0,0.3)",
//     "box-sizing:border-box"
//   ].join(";");

//   var title = document.createElement("h2");
//   title.textContent = TITLE;
//   title.style.cssText = "margin:0 0 12px 0;font-size:20px;color:#1a1a1a;";

//   var desc = document.createElement("p");
//   desc.textContent = DESCRIPTION;
//   desc.style.cssText = "margin:0 0 20px 0;font-size:14px;line-height:1.5;color:#333333;white-space:pre-line;";

//   var buttonRow = document.createElement("div");
//   buttonRow.style.cssText = "display:flex;justify-content:flex-start;";

//   var confirmBtn = document.createElement("button");
//   confirmBtn.textContent = "I confirm";
//   confirmBtn.style.cssText = [
//     "background:#1a1a1a",
//     "color:#ffffff",
//     "border:none",
//     "padding:10px 20px",
//     "font-size:14px",
//     "border-radius:4px",
//     "cursor:pointer"
//   ].join(";");
//   confirmBtn.onmouseover = function () { confirmBtn.style.opacity = "0.85"; };
//   confirmBtn.onmouseout = function () { confirmBtn.style.opacity = "1"; };

//   confirmBtn.addEventListener("click", function () {
//     document.body.removeChild(overlay);
//     document.body.style.overflow = ""; // restore scroll
//   });

//   buttonRow.appendChild(confirmBtn);
//   modal.appendChild(title);
//   modal.appendChild(desc);
//   modal.appendChild(buttonRow);
//   overlay.appendChild(modal);

//   // ---- Show on every page load ----
//   document.addEventListener("DOMContentLoaded", function () {
//     document.body.appendChild(overlay);
//     document.body.style.overflow = "hidden"; // prevent background scroll while open
//   });
// })();
